import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { PalletModel } from './pallet.model';


export class PalletAckResponse extends GlobalResponseObject{
    data?: PalletModel[];
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data 
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: PalletModel[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}
 